import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type StoreService from 'tio-employee/services/store';

export default class PslfEmployerNonPartnerSignRoute extends Route {
  @service declare store: StoreService;

  async model() {
    const params = this.paramsFor('pslf-employer');

    const employerFormInfo = await this.store
      .adapterFor('pslf-form')
      // @ts-expect-error: adapter
      .verifyNonPartnerEmployer(params.form_document_id, params.approval);

    return {
      employerFormInfo,
      approvalId: params.approval,
      documentId: params.form_document_id,
    };
  }
}
